import * as React from "react";
import TextInput from "src/components/shared/Inputs/TextInput";
import { StartTimerButton } from "../Timer.components";

interface Props {
  minutesValue: number | string;
  onMinutesValueChange: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void | Promise<void>;
  onStartTimer: () => void | Promise<void>;
}

export const TimerIdleMenu: React.FunctionComponent<Props> = ({
  minutesValue,
  onMinutesValueChange,
  onStartTimer,
}) => {
  return (
    <div>
      <TextInput
        aria="minutes"
        label="Minutes"
        type="text"
        value={minutesValue}
        onChange={onMinutesValueChange}
      />
      <StartTimerButton themeColor="buttonPrimary" onClick={onStartTimer}>
        Start Timer
      </StartTimerButton>
    </div>
  );
};
